import React from "react";
import PropTypes from "prop-types";
import { Translations } from "../translations";
import DocumentLink from "./DocumentLink";

const AutoId = ({ autoIdLink, className, btnSize }) => {
  if (!autoIdLink) {
    return <span>No Auto ID Cards</span>;
  }

  return (
    <DocumentLink
      className={className}
      pdfUri={autoIdLink}
      filename={"AutoId_Cards.pdf"}
      btnSize={btnSize}
      inline={true}
    >
      <span>{Translations.account_summary.auto_id}</span>
    </DocumentLink>
  );
};

AutoId.propTypes = {
  autoIdLink: PropTypes.string,
  className: PropTypes.string,
  btnSize: PropTypes.string
};

export default AutoId;
